var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fetch-spinner-modal"},[_c('div',{staticClass:"fetch-spinner-modal__spinner"})])
}]

export { render, staticRenderFns }